import { render } from "./ReleaseReportPage.vue?vue&type=template&id=6bc7952e&scoped=true"
import script from "./ReleaseReportPage.vue?vue&type=script&lang=js"
export * from "./ReleaseReportPage.vue?vue&type=script&lang=js"

import "./ReleaseReportPage.vue?vue&type=style&index=0&id=6bc7952e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc7952e"]])

export default __exports__